import { DataSecurityLevel, KnownInstrumentationEvents, } from '@office-start/instrumentation-types';
import { generateEvent } from '../InstrumentationService';
export function logErrorEvent(eventName, params, metrics, securityThreshold) {
    if (params === void 0) { params = {}; }
    if (metrics === void 0) { metrics = []; }
    if (securityThreshold === void 0) { securityThreshold = DataSecurityLevel.Security; }
    generateEvent(eventName, KnownInstrumentationEvents.AppError, securityThreshold, params, metrics, true);
}
//# sourceMappingURL=logErrorEvent.js.map